// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    /* Store Custom Code - Start */
    accordion: {
        padding: {
            horizontal: pxToRemArray([18]),
            vertical: pxToRemArray([18]),
        },
        spacing: pxToRemArray([8, null, 16]),
    },
    form: {
        actions: {
            spacing: "1.8em",
        },
        grid: {
            small: {
                vertical: ["1em"],
            },
            base: {
                vertical: ["1.4em"],
            },
        },
    },
    layout: {
        contentWidth: 1350,
        spacing: {
            side: pxToRemArray([20, 40, null, 45, null]),
            content: pxToRemArray([32, null, 40, null, 45]),
            narrowContent: pxToRemArray([32, null, 40, null, null]),
            spacedContent: pxToRemArray([60, null, null, null, 70]),
        },
        bannerBorderRadius: pxToRem(0, 0, 200),
        bannerBorderRadiusMobile: pxToRem(0, 0, 100),
    },
    header: {
        height: pxToRemArray([88]),
        padding: pxToRemArray([20]),
        itemSpacing: pxToRemArray([12, null, 16, 24, 32]),
        subItemSpacing: pxToRemArray([12, null, 12, 16, 24]),
        iconButton: {
            size: pxToRemArray([24]),
            padding: pxToRemArray([6, null, 0]),
        },
    },
    menu: {
        mainNavigation: {
            height: pxToRemArray([45]),
            itemSpacing: pxToRemArray([16]),
            underlineSize: pxToRem(2),
        },
        secondaryNavigation: {
            height: pxToRemArray([42]),
            itemSpacing: [pxToRem(30)],
        },
        tertiaryNavigation: {
            height: pxToRemArray([50]),
        },
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
        /* Store Custom Code - Start */
        detail: {
            contentSpacing: pxToRem(25),
        },
        list: {
            contentSpacing: pxToRem(10),
        },
        /* Store Custom Code - End */
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    typography: {
        fontFamily: {
            title: `"Roboto", Arial, Helvetica, sans-serif`,
            base: `"Roboto", Arial, Helvetica, sans-serif`,
        },
        /* Store Custom Code - Start */
        lineHeight: {
            small: 1.2,
            semi: 1.4,
            base: 1.4,
        },
        size: {
            larger: pxToRem(21),
            largest: pxToRem(30),
        },
        /* Store Custom Code - End */
    },
};

export default design;
